import React, { useState, useEffect, useContext } from "react";

import { AppContext } from "../AppContext";

import LoadingComp from "./common/LoadingComp";
import SummaryitemComp from "./SummaryItemComp";

import DetailPopup from "./common/DetailPopup";

import TileComp from "./common/TileComp";

import AttestationListComp from "./attestations/AttestationListComp";
import AttestationDetailPopup from "./attestations/AttestationDetailPopup";
import PreTradeListComp from "./pretrade/PreTradeListComp";

import { fetchCall } from "../common/FetchHelpers";

const HomeComp = () => {
    const urlSummary = "api/dashboard/summary";
    const [appContext, setAppContext] = useContext(AppContext);
    const isJwCole = appContext.clientId === "jwcole" ? true : false;
    const isASN = appContext.clientId === "asn" ? true : false;
    const [loading, setLoading] = useState(true);
    const [summary, setSummary] = useState({});
    const [dataFrame, setDataFrame] = useState({ startIndex: 0, limit: 10 });

    const [showDetail, setShowDetail] = useState(false);
    const [showAttestationDetail, setShowAttestationDetail] = useState(false);
    const [detailItem, setDetailItem] = useState({});

    const app_feaatures = JSON.parse(appContext.appFeature.EMP_PORTAL_FEATURES);


    const onItemDetail = (item) => {
        try {
            if (item.attachments) {
                item.attachments = item.attachments.map(x => (
                    {
                        ...x,
                        name: x.fileName,
                        type: x.mimeType
                    })
                );
            }
            if(item.templateStr)
            {
                item.template = {}; 
                item.template.templateStr = item.templateStr;
            }
        } catch (e) {
            console.log(e);
        }
        setDetailItem(item);
        setShowDetail(true);
    };

    const onAttestationDetail = (item) => {
        setDetailItem(item);
        setShowAttestationDetail(true);
    }

    const updateAttestationStatus = (item) => {
        summary.attestation.find(x => x.id == item.id).status = item.status;
        summary.attestation.find(x => x.id == item.id).statusLabel = item.statusLabel;
        setSummary(summary);
    }

    const handleClose = (reload) => {
        setShowDetail(false);
        setShowAttestationDetail(false);

        if (reload) {
            loadData();
        }

    };



    const loadData = () => {
        setLoading(true);

        fetchCall(urlSummary)
            .then((result) => {
                setSummary(result);
                setAppContext({...appContext, notificationCount:result.notificationCount });
                localStorage.setItem("NOTIFICATION_COUNT", result.notificationCount);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            }
            );
    }

    useEffect(() => {
        loadData();

    }, []);


    const ShowSummary = () => {
        return (
            <div className="tile-container-dashboard">

                { app_feaatures.features.request_types.some(req_type => req_type.name === 'Attestation') &&
                    <TileComp title="Attestations" footer={"Showing last " + summary.attestation.length + " Attestation Document(s)"} moreLink="attestation">
                        <AttestationListComp items={summary.attestation} dataFrame={dataFrame} onDetail={onAttestationDetail} />
                    </TileComp>
                }
                
                { app_feaatures.features.request_types.some(req_type => req_type.name === 'Document') &&
                <TileComp title="Documents" footer={"Showing last " + summary.documents.length + " Document(s)"} moreLink="documents">
                    <SummaryitemComp header="Document" items={summary.documents} onDetail={onItemDetail} />
                </TileComp>
                }
                
                { (app_feaatures.features.request_types.some(req_type => req_type.name === 'OBA') || app_feaatures.features.request_types.some(req_type => req_type.name === 'Gift') || app_feaatures.features.request_types.some(req_type => req_type.name === 'Political') ) &&
                <TileComp title="Submitted Business Requests" footer={"Showing last " + summary.otherRequest.length + " Other Business Request(s)"}>
                    <SummaryitemComp header="Submitted Business Request Request" items={summary.otherRequest} onDetail={onItemDetail} />
                </TileComp>
                }

                { app_feaatures.features.request_types.some(req_type => req_type.name === 'PreTrade') &&
                    <TileComp title="Submitted Pre-Trade Requests" footer={"Showing last " + summary.preTrade.length + " Pre-Trade Request(s)"} moreLink="pretrade">
                        <PreTradeListComp items={summary.preTrade} dataFrame={dataFrame} onDetail={onItemDetail} />
                    </TileComp>
                }


                {showDetail &&
                    <DetailPopup data={detailItem} handleClose={handleClose} />
                }

                {showAttestationDetail &&
                    <AttestationDetailPopup data={detailItem} updateAttestationStatus={updateAttestationStatus} handleClose={handleClose} />
                }

            </div>
        );
    };

    return (

        <div className={appContext.sidebarCollapsed ? "content-wrapper sidebar-collapsed" : "content-wrapper"}>
            <section className="sectoin-wrapper">
                <div className="page-title">Attestation & Request Summary</div>
                <div className="section-content">
                    {loading ? <LoadingComp /> : <ShowSummary />}
                </div>
            </section>
        </div>
    );
};

export default HomeComp;
